<template>
  <div>
    <section class="group-edit ly-edit">
      <div class="section-inner">
        <div class="section-cont">
          <h2>조직 관리</h2>
          <p class="site-path">
            <span>Home</span>&nbsp;&gt;&nbsp;
            <span>EDUCATION</span>&nbsp;&gt;&nbsp;
            <span>조직 관리</span>
          </p>
          <!-- /.site-path -->
          <table>
            <colgroup>
              <col class="col1" />
              <col class="col2" />
            </colgroup>
            <tr>
              <th scope="row">
                <label for="admin-level">부서 선택</label>
              </th>
              <td>
                <span>
                  <select
                    name="admin-level"
                    id="admin-level"
                    v-model="department"
                  >
                    <option
                      v-for="item in getDepartmentList"
                      v-bind:key="item.id"
                      :value="item"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </span>
              </td>
            </tr>
            <tr>
              <th scope="row"><label for="name">성함</label></th>
              <td>
                <input type="text" name="name" id="name" v-model="name" />
              </td>
            </tr>
            <tr>
              <th scope="row"><label for="position">직함</label></th>
              <td>
                <input
                  type="text"
                  name="position"
                  id="position"
                  v-model="title"
                />
              </td>
            </tr>
            <tr>
              <th scope="row"><label for="admin-name">이력</label></th>
              <td>
                <ckeditor
                  :editor="editor"
                  v-model="editorData"
                  :config="editorConfig"
                  class="text-area"
                ></ckeditor>
              </td>
            </tr>
            <tr>
              <th scope="row">이미지</th>
              <td class="attached-file file-cell">
                <p v-if="file">{{ file.name }}</p>
                <p v-else class="file-empty"></p>
                <file-select v-model="file"></file-select>
                <span>
                  사이즈 : 250 x 300px / 용량 : 10MB 이하 업로드 (jpg / png /
                  gif / bmp)</span
                >
              </td>
            </tr>
            <tr>
              <th scope="row"><label for="group-num">노출 순번</label></th>
              <td>
                <input
                  type="text"
                  name="group-num"
                  id="group-num"
                  v-model="order"
                />
                <span>숫자가 낮을수록 빠른 순으로 표기 됩니다.</span>
              </td>
            </tr>
          </table>
          <!-- /.table-->
          <!-- /.table-->

          <router-link :to="{ name: 'GroupList' }" class="btn-white" tag="a"
            >목록</router-link
          >
          <button class="btn-blue btn-right" @click="onSubmitModify">
            수정
          </button>
          <!-- /.btn -->
        </div>
        <app-footer />
      </div>
    </section>
  </div>
</template>

<script>
import AppFooter from "../../AppFooter.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import FileSelect from "../..//FileSelect.vue";

export default {
  props: ["id", "item"],
  components: { AppFooter, FileSelect },
  name: "GroupEdit",
  data() {
    return {
      file: {},

      name: "",
      title: "",
      order: null,
      department: null,

      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        // The configuration of the editor.
        toolbar: [],
      },
      department_list: [],
      attachment: null,
    };
  },
  computed: {
    getDepartmentList: function () {
      return this.department_list;
    },
  },
  created() {
    // props are exposed on `this`
    console.log("props id => ", this.id);
    console.log("props item => ", this.item);

    this.name = this.item.name;
    this.title = this.item.title;
    this.editorData = this.item.job_history;
    this.order = this.item.order;
    this.department = this.item.department;

    if (this.item.attachment != null) {
      this.attachment = this.item.attachment;
      this.file.name = this.item.attachment.originalname;
    }

    // 부서정보 데이터 요청
    this.$store
      .dispatch("education/req_department_list", {})
      .then((result) => {
        console.log("req_department_list result => ", result);
        this.department_list = result.data;
      })
      .catch((err) => {
        console.log(" error => ", err);
      });
  },
  methods: {
    onSubmitModify() {
      console.log("onSubmitModify. -----");

      // file 에 File object 가 있으면 파일을 새로 선택한것임.
      console.log("file instance ?? => "); // true

      var isFileSelected = this.file instanceof File;
      if (isFileSelected) {
        // 파일 선택이 있었음.
      }

      /// TODO 첨부파일 수정 일괄 작업 예정.
      const payload = {
        id: this.item.id,
        name: this.name,
        title: this.title,
        job_history: this.editorData,
        order: this.order,
        department_id: this.department.id,
      };

      this.$store
        .dispatch("education/req_update_employee", payload)
        .then(() => {
          this.$alert("수정하였습니다.").then(() => {
            this.$router.push({ name: "GroupList" });
          });
        })
        .catch((error) => {
          console.log("error => ", error);
        });
    },
  },
};
</script>
<style lang="scss" scoped></style>
<style scoped>
select {
  width: 250px !important;
}
input[name="group-num"] {
  width: 150px !important;
  display: inline-block !important;
  margin-right: 20px !important;
}
input[name="group-num"] + span {
  color: #ff4141;
}
span {
  font-size: 16px;
}
</style>
